import { createContext } from "react";

export const SubrubrosContext = createContext()
export const SubrubrosFormContext = createContext()
export const SubrubrosReportContext = createContext()